/* =========================================================
   Bestcold — "Welke airco heb ik nodig?" keuzehulp
   ---------------------------------------------------------
   V7 (4-10-2026) — m³ is leidend.

   WAT ER VERANDERDE T.O.V. V6
   V6 rekende met m²-ranges per model (9-16, 14-22, 20-35, 27-45) en
   schaalde op met vermenigvuldigingsfactoren voor isolatie en ruimtetype,
   plus een volledige modelstap zodra "hoog plafond" of "veel glas/zon"
   was aangevinkt. Dat laatste was de zwaarste ingreep in de hele keten:
   rond de grens 3,5 -> 5,0 kW was één vinkje +59% capaciteit. Daardoor
   adviseerde de tool stelselmatig te zwaar.

   V7 volgt de bevestigde Bestcold-businessregels:

     1. De klant voert oppervlakte in m² in (dat blijft de kracht van de
        tool) en de plafondhoogte in meters. De inhoud wordt INTERN
        berekend; de klant hoeft nooit zelf in kuubs te denken.

            inhoud_m3 = oppervlakte_m2 x plafondhoogte_m

     2. Gekozen wordt het LICHTSTE model waarvan de maximale inhoud de
        berekende inhoud dekt. Die maxima komen uit het Shopify-metafield
        custom.recommended_m3 en staan op 90 / 120 / 180 / 240 m³ -- exact
        de waarden die Bestcold ook op de productpagina's publiceert.

     3. Slecht geïsoleerd: 10 m³ van de capaciteit per unit af, voordat
        je een maat groter pakt. Letterlijk Gerwin, 4-10-2026:
        "Zeg als je slecht geïsoleerd hebt je er 10m3 afhaalt per unit.
        Voordat je een groter model moet pakken."
        Effectief dus 80 / 110 / 170 / 230 m³.

     4. Boven het zwaarste model: maatwerkmelding. Nooit eindigen met
        "geen airco beschikbaar".

   WAT ER IS WEGGEHAALD, EN WAAROM
   De isolatiefactoren (1,0 / 1,08 / 1,2), de ruimtetypefactoren (zolder
   1,15, kantoor 1,02), het vinkje "hoog plafond", het vinkje "veel glas
   of veel zon" en het veld "gebruik" zijn uit de selectie verdwenen.
   Voor geen van die correcties bestaat een bevestigde Bestcold-regel, en
   een factor verzinnen is in dit project niet toegestaan. "Hoog plafond"
   is bovendien overbodig geworden: de werkelijke plafondhoogte zit nu
   rechtstreeks in de m³-berekening in plaats van als kunstmatige
   modelstap. De bijbehorende vragen zijn uit het formulier gehaald in
   plaats van blijven staan zonder effect -- een vraag die het antwoord
   niet beïnvloedt is schijnnauwkeurigheid.

   ISOLATIE: WAAROM ALLEEN "MATIG"
   De drie opties zijn Goed / Gemiddeld / Matig. De vertaalsleutel van de
   derde is letterlijk `advisor.insulation_poor`, dus "Matig" IS de
   bestaande slechte-isolatieoptie van deze keuzehulp. Daarop, en alleen
   daarop, gaat de bevestigde -10 m³ toegepast. Goed en Gemiddeld krijgen
   geen bonus: daarvoor is geen regel aangeleverd.

   DE GRENZEN ZIJN INCLUSIEF
   Exact 90 m³ is nog 2,5 kW; 90,01 m³ wordt 3,5 kW. Zelfde principe op
   elke volgende grens. Daarom wordt de berekende inhoud op twee decimalen
   afgerond vóór de vergelijking: 40 x 2,7 is in IEEE-754 niet 108 maar
   108.00000000000001, en zonder die afronding zou een ruimte die exact op
   een grens valt de verkeerde kant op kunnen vallen. Twee decimalen
   bewaren de 0,01-stap die de grensregel vereist.

   De maxima staan NIET in deze code. Ze komen per model uit het metafield
   en worden als max_m3 in de model-JSON gezet (sections/size-advisor.liquid).
   Eén bron voor het advies en voor wat de klant op de productpagina leest.
   ========================================================= */
(function () {
  'use strict';

  /* De enige bevestigde correctie die deze keuzehulp kent. */
  var SLECHTE_ISOLATIE_AFTREK_M3 = 10;
  var SLECHTE_ISOLATIE = 'matig'; // = advisor.insulation_poor

  /* Invoerhygiëne, geen businessregels. Deze grenzen bestaan alleen om
     typefouten en onzinwaarden tegen te houden; een ruimte die groot maar
     aannemelijk is loopt gewoon door naar de maatwerkmelding, want dát is
     het inhoudelijke antwoord op "te groot voor één unit". */
  var M2_MIN = 1;
  var M2_MAX = 1000;
  var HOOGTE_MIN = 1.5;
  var HOOGTE_MAX = 10;

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /* Nederlandse invoer: "2,7" en "2.7" moeten beide werken. Daarom zijn de
     twee velden `type="text"` met `inputmode="decimal"` en niet
     `type="number"`. In een number-input levert een komma in meerdere
     browsers een LEGE value op, zonder dat je kunt zien wat er getypt is:
     de bezoeker ziet "2,7" staan en de rekenmachine krijgt niets. */
  function leesGetal(raw) {
    if (typeof raw !== 'string') return NaN;
    var s = raw.trim().replace(',', '.');
    if (s === '' || !/^\d*\.?\d+$/.test(s)) return NaN;
    return parseFloat(s);
  }

  function rond2(x) {
    return Math.round(x * 100) / 100;
  }

  /* 81 -> "81", 113.4 -> "113,4" */
  function nlGetal(x) {
    return String(rond2(x)).replace('.', ',');
  }

  function initAll(root) {
    var forms = root.querySelectorAll ? root.querySelectorAll('[data-advisor-form]:not([data-bound])') : [];
    forms.forEach(function (form) {
      form.setAttribute('data-bound', 'true');
      var section = form.closest('.size-advisor');
      if (!section) return;

      var modelsScript = section.querySelector('[data-advisor-models]');
      var resultBox = section.querySelector('[data-advisor-result]');
      var resultCard = section.querySelector('[data-advisor-result-card]');
      var placeholder = section.querySelector('[data-advisor-placeholder]');
      var errorBox = section.querySelector('[data-advisor-error]');
      if (!modelsScript || !resultBox || !resultCard) return;

      var models;
      try {
        models = JSON.parse(modelsScript.textContent).filter(function (m) {
          // Zonder maximale inhoud kan dit model niet in de reeks meedoen.
          return m.title && m.max_m3 > 0;
        });
      } catch (err) {
        return;
      }
      // Oplopend op inhoud: van licht naar zwaar, zodat het eerste model dat
      // de ruimte dekt automatisch het lichtste passende model is.
      models.sort(function (a, b) { return a.max_m3 - b.max_m3; });

      /* ---------------------------------------------------------
         Meting. Alles loopt via window.BestcoldEvents.track, die het
         doorzet naar Shopify's pixel-laag; vandaar gaat het naar GA4.
         Hier wordt niets naar GA4 gestuurd en staat geen meet-ID: het
         thema weet niet waar de data heen gaat, en dat hoort ook zo.

         Ontdubbeling zit op twee plekken:
           - `gestart` zorgt dat advisor_started hooguit een keer per
             paginaweergave vuurt, hoeveel velden de bezoeker ook aanraakt;
           - `laatsteInvoer` vergelijkt de ingevulde waarden met de vorige
             berekening. Twee keer op de knop drukken zonder iets te
             wijzigen is geen nieuw advies en levert dus geen tweede
             advisor_completed of advisor_recommendation op. Wijzigt de
             bezoeker wel iets, dan is het wel een nieuwe berekening: dat
             is precies het gedrag dat we willen zien.
         --------------------------------------------------------- */
      var gestart = false;
      var laatsteInvoer = null;

      function meet(naam, eigenschappen) {
        try {
          if (window.BestcoldEvents && typeof window.BestcoldEvents.track === 'function') {
            window.BestcoldEvents.track(naam, eigenschappen || {});
          }
        } catch (err) { /* meten mag nooit het advies breken */ }
      }

      form.addEventListener('input', markeerStart, true);
      form.addEventListener('change', markeerStart, true);
      function markeerStart() {
        if (gestart) return;
        gestart = true;
        meet('advisor_started', {});
      }

      /* De resultaatkaart wordt bij elke berekening opnieuw opgebouwd, dus
         listeners op de knoppen zelf zouden zich opstapelen. Daarom een
         listener op de omliggende container, een keer. */
      resultBox.addEventListener('click', function (e) {
        var cta = e.target.closest ? e.target.closest('[data-advisor-cta]') : null;
        if (!cta) return;
        var soort = cta.getAttribute('data-advisor-cta');
        if (soort === 'product') {
          meet('advisor_product_click', {
            model: cta.getAttribute('data-advisor-model') || '',
            inhoud_m3: Number(cta.getAttribute('data-advisor-m3')) || 0
          });
        } else if (soort === 'contact') {
          meet('advisor_custom_contact', {
            inhoud_m3: Number(cta.getAttribute('data-advisor-m3')) || 0
          });
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!models.length) return;

        var data = new FormData(form);
        var oppervlakte = leesGetal(data.get('room_m2'));
        var hoogte = leesGetal(data.get('ceiling_h'));

        if (isNaN(oppervlakte) || oppervlakte < M2_MIN || oppervlakte > M2_MAX) {
          meldFout(strings().errorM2, '#AdvisorRoomSize');
          return;
        }
        if (isNaN(hoogte) || hoogte < HOOGTE_MIN || hoogte > HOOGTE_MAX) {
          meldFout(strings().errorHeight, '#AdvisorCeilingHeight');
          return;
        }
        wisFout();

        var inhoud = rond2(oppervlakte * hoogte);
        var isolatie = data.get('insulation');
        var slecht = isolatie === SLECHTE_ISOLATIE;
        var aftrek = slecht ? SLECHTE_ISOLATIE_AFTREK_M3 : 0;

        // Zelfde invoer als de vorige keer: geen nieuwe berekening, dus ook
        // geen nieuwe events. Het advies wordt wel gewoon opnieuw getoond.
        var invoersleutel = oppervlakte + '|' + hoogte + '|' + isolatie;
        var nieuweBerekening = invoersleutel !== laatsteInvoer;
        laatsteInvoer = invoersleutel;

        if (nieuweBerekening) {
          markeerStart();
          meet('advisor_completed', {
            oppervlakte_m2: oppervlakte,
            plafondhoogte_m: hoogte,
            isolatie: isolatie,
            inhoud_m3: inhoud
          });
        }

        // Het lichtste model waarvan de effectieve inhoud de ruimte dekt.
        var keuze = null;
        var effectieveCapaciteit = 0;
        for (var i = 0; i < models.length; i++) {
          var cap = models[i].max_m3 - aftrek;
          if (cap > 0 && inhoud <= cap) {
            keuze = models[i];
            effectieveCapaciteit = cap;
            break;
          }
        }

        if (!keuze) {
          if (nieuweBerekening) {
            meet('advisor_recommendation', {
              model: 'maatwerk',
              maatwerk: true,
              inhoud_m3: inhoud
            });
          }
          renderCustom(oppervlakte, hoogte, inhoud);
          return;
        }
        if (nieuweBerekening) {
          // op_voorraad komt uit de model-JSON; is die er niet, dan sturen we
          // het veld niet mee in plaats van een waarde aan te nemen.
          var aanbeveling = {
            model: keuze.title,
            maatwerk: false,
            inhoud_m3: inhoud,
            capaciteit_m3: effectieveCapaciteit
          };
          if (typeof keuze.available === 'boolean') {
            aanbeveling.op_voorraad = keuze.available;
          }
          meet('advisor_recommendation', aanbeveling);
        }
        renderResult(keuze, effectieveCapaciteit, oppervlakte, hoogte, inhoud, slecht);
      });

      function strings() {
        return window.BestcoldAdvisorStrings || {};
      }

      function meldFout(bericht, selector) {
        if (errorBox) {
          errorBox.textContent = bericht || '';
          errorBox.hidden = !bericht;
        }
        var veld = form.querySelector(selector);
        if (veld) veld.focus();
      }

      function wisFout() {
        if (errorBox) {
          errorBox.textContent = '';
          errorBox.hidden = true;
        }
      }

      /* De rekenregel terug aan de bezoeker: oppervlakte x hoogte = inhoud.
         Dit is bewust zichtbaar -- het is de berekening die hij zelf heeft
         ingevoerd, en het maakt navolgbaar waarom dit model eruit komt.
         Het zijn GEEN modelcapaciteiten in m²; die blijven onzichtbaar. */
      function rekenregel(m2, h, m3) {
        var tpl = strings().yourRoom || '';
        return tpl.replace('{{ m2 }}', nlGetal(m2))
                  .replace('{{ hoogte }}', nlGetal(h))
                  .replace('{{ m3 }}', nlGetal(m3));
      }

      /* Maatwerk: geen product, geen prijs, geen koop-CTA -- alleen een
         contactroute. Nooit "geen airco beschikbaar". */
      function renderCustom(m2, h, m3) {
        var s = strings();
        var html = '<div class="size-advisor__result-info">';
        html += '<p class="size-advisor__result-eyebrow">' + escapeHtml(s.customTitle || 'Maatwerkadvies') + '</p>';
        html += '<h3>' + escapeHtml(s.customTitle || 'Maatwerkadvies') + '</h3>';
        if (s.yourRoom) {
          html += '<p class="size-advisor__result-area">' + escapeHtml(rekenregel(m2, h, m3)) + '</p>';
        }
        html += '<p class="size-advisor__result-note">' + escapeHtml(s.customBody || '') + '</p>';
        html += '<a href="' + (s.contactUrl || '/pages/contact') + '" class="btn btn--primary"'
             + ' data-advisor-cta="contact" data-advisor-m3="' + rond2(m3) + '">'
             + escapeHtml(s.contactCta || 'Neem contact op') + '</a>';
        html += '</div>';
        paint(html);
      }

      function renderResult(model, capaciteit, m2, h, m3, slecht) {
        var s = strings();
        var html = '';

        if (model.image) {
          html += '<img src="' + model.image + '" alt="' + escapeHtml(model.title) + '" class="size-advisor__result-image" loading="lazy">';
        }
        html += '<div class="size-advisor__result-info">';
        html += '<p class="size-advisor__result-eyebrow">' + (s.weAdvise || 'Wij adviseren') + '</p>';
        html += '<h3>' + escapeHtml(model.title) + '</h3>';

        if (s.yourRoom) {
          html += '<p class="size-advisor__result-area">' + escapeHtml(rekenregel(m2, h, m3)) + '</p>';
        }
        if (model.price) {
          html += '<p class="size-advisor__result-price">' + model.price + '</p>';
        }
        // Capaciteit altijd in m³, nooit in m². De 90/120/180/240 is
        // bestaande publieke modelcommunicatie; bij matige isolatie staat
        // er de afgeleide waarde met de reden erbij.
        if (slecht && s.insulationNote) {
          html += '<p class="size-advisor__result-note">'
                + escapeHtml(s.insulationNote
                    .replace('{{ aftrek }}', String(SLECHTE_ISOLATIE_AFTREK_M3))
                    .replace('{{ m3 }}', nlGetal(capaciteit)))
                + '</p>';
        } else if (s.modelCapacity) {
          html += '<p class="size-advisor__result-note">'
                + escapeHtml(s.modelCapacity.replace('{{ m3 }}', nlGetal(capaciteit)))
                + '</p>';
        }
        if (!model.available) {
          html += '<p class="size-advisor__result-note">' + (s.soldOut || '') + '</p>';
        }
        html += '<a href="' + model.url + '" class="btn btn--primary"'
             + ' data-advisor-cta="product" data-advisor-model="' + escapeHtml(model.title) + '"'
             + ' data-advisor-m3="' + rond2(m3) + '">'
             + (s.viewModel || 'Bekijk model') + '</a>';
        if (s.methodNote) {
          html += '<p class="size-advisor__result-factors">' + escapeHtml(s.methodNote) + '</p>';
        }
        html += '</div>';
        paint(html);
      }

      function paint(html) {
        resultCard.innerHTML = html;
        resultBox.hidden = false;
        if (placeholder) placeholder.hidden = true;
        resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
      }
    });
  }
})();
